import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import { useDispatch } from 'react-redux';

import { ForgotPassword, Form, StyledInput } from '../../Login/style';
import { CommonButton } from '../Buttons';

import { authUser } from '../../../actions/Auth';

export const FormLogin = ({ setFirstAcess }) => {
  const dispatch = useDispatch();

  const [login, setLogin] = useState({
    cpf: '',
    senha: '',
  });

  const [loading, setLoading] = useState(false);

  const handleUser = async () => {
    setLoading(true);
    try {
      await dispatch(await authUser(login));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form autoComplete="off" noValidate>
      <StyledInput
        onChange={(e) => setLogin({ ...login, cpf: e.target.value })}
        inputProps={{ maxLength: 11 }}
        label="Login (CPF - Apenas números)"
        variant="outlined"
      />
      <StyledInput marginbottom={8} label="Senha" type="password" variant="outlined" onChange={(e) => setLogin({ ...login, senha: e.target.value })} />
      {/* <ForgotPassword onClick={() => setFirstAcess(true)}>Primeiro Acesso?</ForgotPassword> */}
      <br />
      <CommonButton loading={loading ? true : false} disabled={login.cpf && login.senha ? false : true} label="Acessar" action={() => handleUser()} />
    </Form>
  );
};
